const greet = ["Thank you for your interest in Humans Softtech services. Please provide the following information about your project needs to help us serve you better. This information will enable us to route your request to the appropriate person. You should receive a response as soon as possible."]

const Constrings = {
    greet
}

export default Constrings;